// querySuggestionsPlugin.tsx
// Provides an Algolia Autocomplete plugin for general query suggestions.
// Integrates with Algolia to fetch and display search query suggestions.

import React, { Fragment } from 'react';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import Link from 'next/link';

interface SetInstantSearchUiStateOptions {
  query: string;
  category?: string;
}

export function createQuerySuggestionsPluginReact({
  searchClient,
  indexName,
  currentCategory,
  setInstantSearchUiState,
}: {
  searchClient: any;
  indexName: string;
  currentCategory: string | undefined;
  setInstantSearchUiState: (options: SetInstantSearchUiStateOptions) => void;
}) {
  return createQuerySuggestionsPlugin({
    searchClient,
    indexName,
    getSearchParams() {
      return { hitsPerPage: 10 };
    },
    categoryAttribute: [indexName, 'facets', 'exact_matches', 'categories.en-GB.lvl0'],
    transformSource({ source }) {
      return {
        ...source,
        sourceId: 'querySuggestionsPlugin',
        onSelect({ item }) {
          setInstantSearchUiState({
            query: item?.query,
            category: item?.__autocomplete_qsCategory || '',
          });
          if (item?.query) {
            window.location.href = `/search/${encodeURIComponent(item?.query)}`;
          }
        },
        getItems(params) {
          return source?.getItems(params);
        },
        templates: {
          ...source?.templates,
          header({ state }) {
            if (!state?.query) return <Fragment />;
            if (!currentCategory) return <Fragment />;
            return (
              <Fragment>
                <span className="aa-SourceHeaderTitle">In other categories</span>
                <span className="aa-SourceHeaderLine" />
              </Fragment>
            );
          },
          item({ item, components }) {
            return (
              <Link href={`/search/${encodeURIComponent(item?.query)}`}>
                <div className="aa-QuerySuggestionItem">
                  <Fragment>
                    <components.Highlight hit={item} attribute="query" />
                  </Fragment>
                </div>
              </Link>
            );
          },
        },
      };
    },
  });
}
